import React from "react";
import { View, StyleSheet, Image, FlatList } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import { colors } from "@constants/theme";

interface LineItem {
  product_name: string;
  product_image: string;
  quantity?: number;
  amount_txt: string;
  amount_subtitle: string;
}

interface PickupPlanProps {
  title: string;
  lines: LineItem[];
}

const PickupComponent: React.FC<PickupPlanProps> = ({
  title = "",
  lines = [],
}) => {
  const renderItem = ({ item }: { item: LineItem }) => (
    <View style={styles.lineItem}>
      <View style={styles.imageContainer}>
        <Image
          source={{ uri: item.product_image }}
          style={styles.itemImage}
          resizeMode="cover"
          alt="Product Image"
        />
      </View>
      <View style={styles.lineTextContainer}>
        <Text variant="body_text_2">{item.product_name}</Text>
        <Text variant="caption_4" style={styles.lineText}>
          {`Picked Qty : ${item.quantity}`}
        </Text>
      </View>
      <View style={styles.lineTextContainer2}>
        <Text variant="body_text_2">{item.amount_txt}</Text>
        <Text variant="caption_3" style={styles.lineText}>
          {item.amount_subtitle}
        </Text>
      </View>
    </View>
  );

  return (
    <View>
      <Text variant="title_18_regular">{title}</Text>
      <FlatList
        data={lines}
        renderItem={renderItem}
        keyExtractor={(item, index) => index.toString()}
        showsVerticalScrollIndicator={false}
        ListFooterComponent={() => <View style={{ height: 50 }} />}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  lineItem: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: 12,
    marginVertical: 10,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    borderWidth: 1,
    borderColor: color.lighterBlack,
    flex: 1,
  },
  lineText: {
    color: color.black06,
  },
  itemImage: {
    height: 50,
    width: 50,
  },
  imageContainer: {
    borderRadius: 8,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    padding: 6,
    height: 60,
    width: 60,
    justifyContent: "center",
    alignItems: "center",
  },
  lineTextContainer: {
    marginLeft: 12,
    justifyContent: "space-between",
    height: "100%",
    paddingVertical: 4,
    flex: 1,
  },
  lineTextContainer2: {
    marginLeft: 12,
    justifyContent: "flex-start",
    paddingVertical: 4,
    alignItems: "flex-end",
    height: "100%",
  },
});

export default PickupComponent;
